<template>
  <section class="skeleton-container">
    <div
      v-for="n in Array(3)"
      :key="n"
      class="card is-flex is-flex-direction-row is-align-content-center is-justify-content-center m-b-10 p-4 has-border-light is-radius-large"
    >
      <div
        class="is-flex is-justify-content-center is-flex-direction-column is-full-width m-t-10 m-b-10"
      >
        <SkeletonView height="15" width="80%" />
      </div>
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateSelectionModalSkeleton',
  components: {
    SkeletonView
  }
};
</script>
